import classNames from 'clsx'
import { bool, node, string } from 'prop-types'

import './TextWithIcon.scss'

const TextWithIcon = ({
  centered,
  between,
  inline,
  alignToTop,
  icon,
  iconClassName,
  iconRound,
  right,
  children,
  alignIconToTop,
  qaId,
}) => {
  const iconSize = icon?.props.size

  const className = classNames('l-flex', {
    'l-flex--center': centered,
    'l-flex--distribute-space': between,
    'l-flex--inline': inline,
    'l-flex--start': alignToTop || iconRound,
    'u-padding-large--top': iconRound,
    'm-TextWithIcon': true,
  })
  const allIconClassNames = classNames('m-TextWithIcon__icon', iconClassName, {
    'u-margin-xx-small--right': iconSize !== 'large' && !right,
    'u-margin--right': iconSize === 'large' && !right,
    'u-margin-xx-small--left': iconSize !== 'large' && right,
    'u-margin--left': iconSize === 'large' && right,
    'm-TextWithIcon__icon--round u-margin-large--right': iconRound,
    'l-flex__start': alignIconToTop,
  })

  const renderedIcon = icon && <div className={allIconClassNames}>{icon}</div>

  return (
    <div data-qa-id={qaId} className={className}>
      {!right && renderedIcon}
      <div className="m-TextWithIcon__text">{children}</div>
      {right && renderedIcon}
    </div>
  )
}

TextWithIcon.propTypes = {
  className: string,
  id: string,
  icon: node,
  centered: bool,
  between: bool,
  inline: bool,
  right: bool,
  alignToTop: bool,
  iconClassName: string,
  iconRound: bool,
  children: node,
  alignIconToTop: bool,
  qaId: string,
}

TextWithIcon.defaultProps = {
  className: null,
  id: null,
  icon: null,
  centered: false,
  between: false,
  inline: false,
  right: false,
  alignToTop: null,
  iconClassName: null,
  iconRound: null,
  alignIconToTop: false,
}

export default TextWithIcon
